module.exports = __webpack_public_path__ + "img/cd.09b55412.png";